var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeWater/header.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "back",
    on: {
      click: _vm.backClick
    }
  }, [_c("img", {
    attrs: {
      src: require("./image/back.png"),
      alt: ""
    }
  })]), _vm.show ? _c("div", {
    staticClass: "operation operation-1",
    on: {
      click: function click($event) {
        _vm.show = false;
      }
    }
  }, [_c("i", {
    staticClass: "el-icon-caret-left",
    staticStyle: {
      transform: "translateX(20%)"
    }
  }), _c("i", {
    staticClass: "el-icon-caret-right",
    staticStyle: {
      transform: "translateX(-20%)"
    }
  })]) : _c("div", {
    staticClass: "operation operation-2",
    on: {
      click: function click($event) {
        _vm.show = true;
      }
    }
  }, [_c("i", {
    staticClass: "el-icon-caret-right",
    staticStyle: {
      transform: "translateX(20%)"
    }
  }), _c("i", {
    staticClass: "el-icon-caret-left",
    staticStyle: {
      transform: "translateX(-20%)"
    }
  })]), _c("div", {
    staticClass: "content"
  }, [_vm.show ? _c("div", {
    staticClass: "left"
  }, [_vm._m(0), _vm._m(1), _vm._m(2)]) : _vm._e(), _c("div", {
    staticClass: "center"
  }, [_c("dotBmap", {
    attrs: {
      mapType: "BMAP_HYBRID_MAP",
      createPoint: false,
      createSearch: false,
      mapCenter: _vm.labInfo.geoLat ? {
        lat: _vm.labInfo.geoLat,
        lng: _vm.labInfo.geoLng
      } : {},
      height: "100%",
      zoom: 14
    }
  })], 1), _vm.show ? _c("div", {
    staticClass: "right"
  }, [_c("div", {
    staticClass: "item"
  }, [_vm._m(3), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: _vm.labSpeciesData.speciesImage,
      alt: ""
    }
  }), _c("p", [_vm._v(_vm._s(_vm.labSpeciesData.speciesIntroduction))])])])]), _vm._m(4), _vm._m(5)]) : _vm._e()])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeWater/title.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("全国产量统计（"), _c("span", [_vm._v("单位：")]), _vm._v("万吨）")])]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    attrs: {
      id: "nationalProduction"
    }
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeWater/title.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("省城产量统计（"), _c("span", [_vm._v("单位：")]), _vm._v("吨）")])]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    attrs: {
      id: "provincialProduction"
    }
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeWater/title.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("企业产量预估（"), _c("span", [_vm._v("单位：")]), _vm._v("万吨）")])]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    attrs: {
      id: "labProduction"
    }
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeWater/title.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("养殖品种")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeWater/title.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("价格分析（"), _c("span", [_vm._v("单位：")]), _vm._v("元）")])]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    attrs: {
      id: "marketPrice"
    }
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeWater/title.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("销售区域")])]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    attrs: {
      id: "regionalSales"
    }
  })])]);
}];
render._withStripped = true;
export { render, staticRenderFns };